module.exports = __webpack_public_path__ + "media/question0_en.f92abc65.wav";